import Axios  from "axios"

export const getProducts = (products) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/product/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'PRODUCTS_GET_SUCCESS',
                payload: data.products
            }) 
        }

    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR'           
        })         
    }
}

export const getProductDetail = (product) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/product/get/'+ product, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'PRODUCT_GET_DETAIL_SUCCESS',
                payload: data.product
            })             
        }

    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR'           
        })         
    }
}

export const addProduct = (name, matter) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/product/register', {
                name: name,
                matter: matter
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newProduct = {
                _id: data.id,
                name: name,
                matter: matter
            }
            dispatch({
                type: 'PRODUCT_ADD_SUCCESS',
                payload: newProduct
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_FAIL'
        })
    }
}

export const editProduct = (name, matter, idProduct) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/product/edit/' + idProduct, {
                name: name,
                matter: matter
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'PRODUCT_EDIT_SUCCESS',
            payload: {
                name: name,
                matter: matter,
                _id: idProduct
            }
        })
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR'
        })
    }
}

export const removeProduct = (idProduct) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/product/remove/' + idProduct, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'PRODUCT_DELETE_SUCCESS',
                payload: {
                    idProduct: idProduct,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'PRODUCT_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR'
        })
    }
}

export const activeProduct = (product, active) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const {data,status} = await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/product/activeproduct/'+ product, {
                active: active
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'PRODUCT_ACTIVE_SUCCESS',
                payload: data.product
            })             
        }

    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR'           
        })         
    }
}